export const COMMENT_MODAL_TITLE = "New comments";
export const COMMENT_MODAL_PRIMARY_ACTION_LABEL = "Save";
export const COMMENT_MODAL_SECONDARY_ACTION_LABEL = "Discard";
export const COMMENT_MODAL_TEXTAREA_PLACEHOLDER = "Add a comment";

export const COMMENT_MODAL_TEXTAREA_TEST_ID = "comment-modal-textarea";
